// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TreeTokens } from './type';

const treeTokens: TreeTokens = {
  treeTextPaddingY: 'Padding-2',
  treeCheckboxMarginX: 'Margin-8',
  treeFontSize: '14/regular',
  treeLineHeight: 'Size-18',
  treeSmallFontSize: '12/regular',
  treeSmallLineHeight: 'Size-14',
  treeLargeFontSize: '16/regular',
  treeLargeLineHeight: 'Size-22',
  treeFontColor: 'Neutral-text-5',
  treePaddingX: 'Padding-8',
  treePaddingY: 'Padding-1',
  treeItemFontColor: 'Neutral-text-4',
  treeItemHoverBackgroundColor: 'Neutral-fill-2',
  treeItemHoverFontColor: 'Neutral-text-4',
  treeItemActiveBackgroundColor: 'Neutral-fill-4',
  treeItemActiveFontColor: 'Neutral-text-4',
  treeItemDisabledFontColor: 'Neutral-text-2',
  treeContentHoverBackgroundColor: 'Neutral-fill-2',
  treeContentActiveBackgroundColor: 'Brand-1',
  treeContentActiveFontColor: 'Brand-6',
  treeContentDisabledFontColor: 'Neutral-text-2',
  treeDragBorderColor: 'Brand-6',
  treeDragBackgroundColor: 'Brand-1',
  treeContentBorderRadius: 'Radius-2',
};

export default treeTokens;
